import {
  Box,
  Button,
  ButtonProps,
  IconButton,
  Typography,
} from "@material-ui/core"
import { Mobile } from "common/MediaQueries"
import styled, { DefaultTheme, StyledComponent } from "styled-components"

export const StyledButtonPrimary: StyledComponent<
  typeof Button,
  DefaultTheme,
  { $minWidth?: string },
  never
> = styled(Button)<{ $minWidth?: string }>`
  background-color: #ffbc0d;
  color: ${(p) => (p.disabled ? "#2D2D2DB8" : "#000000")};
  font-size: ${(p) =>
    p.size === "small" ? "20px" : p.size === "medium" ? "24px" : "26px"};
  font-weight: 900;
  line-height: ${(p) =>
    p.size === "small" ? "22px" : p.size === "medium" ? "26.4px" : "28.6px"};
  letter-spacing: 0.015em;
  text-align: center;
  border-radius: ${(p) => (p.size === "small" ? "4px" : "8px")};
  height: ${(p) => (p.size === "small" ? "30px" : "48px")};

  padding: ${(p) =>
    p.size === "small"
      ? "3px 5px"
      : p.size === "medium"
      ? "9.5px 8px"
      : "12px 8px"};
  min-width: ${(p) =>
    p.$minWidth ||
    (p.size === "small" ? "78px" : p.size === "medium" ? "153px" : "328px")};
  .MuiButton-label {
    gap: 4px;
    font-size: ${(p) =>
      p.size === "small" ? "20px" : p.size === "medium" ? "24px" : "26px"};
  }
  .MuiButton-endIcon {
    width: ${(p) => (p.size === "small" ? "20px" : "24px")};
    height: ${(p) => (p.size === "small" ? "20px" : "24px")};
  }
  &:hover {
    background-color: #ffbc0d;
    box-shadow: 0px 4px 8px 0px #2d2d2d29;
    font-size: 26px;
  }

  &:focus {
    background-color: #ffbc0d;
    box-shadow: 0px 4px 8px 0px #2d2d2d29;
  }

  &:active {
    background-color: #f5b511;
  }
`

export const StyledButtonOutlined = styled(Button).attrs({
  variant: "outlined",
})<{ $minWidth?: string }>`
  &.Mui-disabled {
    background-color: #fff;
    color: #2d2d2db8;
  }
  color: #000000;
  font-size: ${(p) =>
    p.size === "small" ? "20px" : p.size === "medium" ? "24px" : "26px"};
  font-weight: 900;
  line-height: ${(p) =>
    p.size === "small" ? "22px" : p.size === "medium" ? "26.4px" : "28.6px"};
  letter-spacing: 0.015em;
  text-align: center;
  border-radius: ${(p) => (p.size === "small" ? "4px" : "8px")};
  height: ${(p) => (p.size === "small" ? "30px" : "48px")};
  border: 2px solid;
  border-color: ${(p) => (p.disabled ? "#F7F7F7" : "#FFBC0D")};
  padding: ${(p) =>
    p.size === "small"
      ? "3px 5px"
      : p.size === "medium"
      ? "9.5px 8px"
      : "12px 8px"};
  min-width: ${(p) =>
    p.$minWidth ||
    (p.size === "small" ? "78px" : p.size === "medium" ? "153px" : "328px")};
  .MuiButton-label {
    gap: 4px;
    font-size: ${(p) =>
      p.size === "small" ? "20px" : p.size === "medium" ? "24px" : "26px"};
  }
  .MuiButton-endIcon {
    width: ${(p) => (p.size === "small" ? "20px" : "24px")};
    height: ${(p) => (p.size === "small" ? "20px" : "24px")};
  }
  &:hover,
  &:focus {
    box-shadow: 0px 4px 8px 0px #2d2d2d29;
    background-color: #f7f7f780;
  }
`

export const StyledIconButton = styled(IconButton)`
  width: 48px;
  height: 48px;
  background-color: #ffbc0d;
  border-radius: 8px;
  .MuiIconButton-label {
    width: 20px;
    height: 20px;
    color: #000000;
    path {
      stroke: #000000;
    }
  }
  &.Mui-disabled {
    background-color: #f7f7f7;
    .MuiIconButton-label path {
      stroke: #757575;
    }
  }
  &:hover,
  &:focus {
    box-shadow: 0px 4px 8px 0px #2d2d2d29;
    background-color: #ffbc0d;
  }
`

const StyledMobileButtonWrapper = styled(Box)`
  position: fixed;
  bottom: 0;
  right: 0;
  width: calc(100% - 32px);
  border-radius: 10px;
  box-shadow: 0px -5px 10px 0px #0000001f;
  background-color: #fff;
  padding: 16px;
  margin-top: 0px;
  z-index: 999;
  margin-bottom: 0px;
  box-sizing: content-box;
  gap: 16px;
  justify-content: space-between;
  align-items: flex-end;
`

const StyledPriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

const StyledPriceLabel = styled(Typography).attrs({ variant: "h5" })`
  font-family: NarkisBlock;
  font-size: 20px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0.015em;
  text-align: right;
  color: #000000;
`

const StyledPrice = styled(Typography).attrs({ variant: "h2" })`
  font-family: NarkisBlock;
  font-size: 40px;
  font-weight: 900;
  line-height: 44px;
  letter-spacing: 0.015em;
  text-align: right;
  color: #000000;
  display: inline-block;
`

const StyledCurrency = styled(Typography).attrs({ variant: "h4" })`
  font-family: NarkisBlock;
  font-size: 26px;
  font-weight: 900;
  line-height: 28.6px;
  letter-spacing: 0.015em;
  text-align: right;
  color: #000000;
  display: inline-block;
`

const StyledDiscount = styled(Typography).attrs({ variant: "h5" })`
  font-family: NarkisBlock;
  font-size: 14px;
  font-weight: 400;
  line-height: 15.4px;
  letter-spacing: 0.015em;
  text-align: right;
  color: #000000;
`

interface MobileButtonWrapperProps extends ButtonProps {
  children: JSX.Element | string
  priceInfo?: {
    label: string
    price: string | number
    discount?: string | number
  }
}

export const MobileButtonWrapper = ({
  children,
  priceInfo,
  ...props
}: MobileButtonWrapperProps) => {
  return (
    <Mobile>
      <StyledMobileButtonWrapper
        style={{
          display: priceInfo ? "flex" : "block",
        }}
      >
        {priceInfo && (
          <StyledPriceWrapper>
            <StyledPriceLabel>{priceInfo.label || ""}</StyledPriceLabel>
            <StyledPrice>
              {priceInfo.price}
              <StyledCurrency>₪</StyledCurrency>
            </StyledPrice>
            <StyledDiscount>
              לאחר שווי הנחה של {priceInfo.discount}%
            </StyledDiscount>
          </StyledPriceWrapper>
        )}
        <StyledButtonPrimary
          size="medium"
          $minWidth={priceInfo ? "184px" : "100%"}
          {...props}
        >
          {children}
        </StyledButtonPrimary>
      </StyledMobileButtonWrapper>
    </Mobile>
  )
}
